import axios from "axios";

let token = null;

if (localStorage.getItem("userAuthEtudiant")) {
  const userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"));
  token = userAuthEtudiant?.user?.api_token || null;
}

const api = axios.create({
  withCredentials: true,
  baseURL: "https://scolarite.backcresus-institut.ovh/api/",
  headers: {
    Authorization: token ? `Bearer ${token}` : "",
    apipassword: "3KbmGc5tZhuDbPtb",
  },
});

// 🔑 Interceptor pour injecter dynamiquement l'année avant chaque requête
api.interceptors.request.use(async (config) => {
  let annee = null;

  // Vérifie dans le localStorage
  if (localStorage.getItem("anneeScolaire")) {
    const anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"));
    annee = anneeScolaire?.Annee?.id || null;
  }

  // Si pas dans le localStorage, récupère depuis l’API
  if (!annee) {
    try {
      const res = await axios.get("https://scolarite.backcresus-institut.ovh/api/annee");
      annee = res.data.Annee[0].CurrentAnnee[0].value;

      // Stocke pour les prochains appels
      localStorage.setItem("anneeScolaire", JSON.stringify({ Annee: { id: annee } }));
    } catch (err) {
      console.error("Erreur récupération année :", err);
    }
  }

  // Injecte dans les headers de la requête en cours
  if (annee) {
    config.headers["annee"] = annee;
  }

  return config;
});

export default api;
